module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/note-d8aa9a20a698652998f92ee64783f860.png";